import { Box, Typography, styled } from "@mui/material";

import { ExpandMoreIcon } from "@/icons";
import { MuiAccordion } from "@/orion/MuiComponents/MuiAccordion";
import { MuiAccordionDetails } from "@/orion/MuiComponents/MuiAccordionDetails";
import { MuiAccordionSummary } from "@/orion/MuiComponents/MuiAccordionSummary";

export const SectionAccordionRoot = styled(MuiAccordion)(({ theme }) => ({
  backgroundColor: theme.palette.background["paper-elevation-1"],
  boxShadow: "none",
  border: "none",
  borderRadius: `${theme.shape.borderRadiusMd}px`,
  overflow: "hidden",
  "&:before": {
    display: "none",
  },
  "&.Mui-expanded": {
    margin: 0,
  },
}));

export const SectionAccordionSummary = styled(MuiAccordionSummary)(
  ({ theme }) => ({
    padding: theme.spacing(4, 5),
    minHeight: 0,
    "& .MuiAccordionSummary-content": {
      alignItems: "center",
      marginTop: 0,
      marginBottom: 0,
    },
  }),
);

export const SectionAccordionDetails = styled(MuiAccordionDetails)(
  ({ theme }) => ({
    paddingTop: 0,
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  }),
);

export const SectionSummaryLeading = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  columnGap: theme.spacing(5),
  flexWrap: "wrap",
  rowGap: theme.spacing(2),
  flex: 1,
  minWidth: 0,
}));

export const SectionIconBadge = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 32,
  height: 32,
  borderRadius: "50%",
  backgroundColor:
    theme.palette.primary.customStateColor?.selected ??
    theme.palette.primary.main,
  color: theme.palette.primary.main,
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightScale.medium,
  color: theme.palette.text.primary,
}));

export const SectionChipRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: theme.spacing(2),
}));

export const SectionExpandIcon = styled(ExpandMoreIcon)(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.text.secondary,
}));
